import api from '../../utils/api'
import { useState, useEffect, useMemo } from "react"
import { FiInbox } from 'react-icons/fi'

/* CSS */

import '../../shared/components/form/inputDefault.css'

/* form */
import Input from "../../shared/components/form/input"

/* Hooks */
import useMyPermission from '../../hooks/useMyPermission'

import ListAccessoryRow from './ListRow/ListAccessoryRow'
import Modal from '../../shared/modal/Modal'
import NewAccessory from './NewAccessory'
import Button from '../../shared/components/Button/Button'


function Accessory() {

    const [token] = useState(localStorage.getItem('token') || '')
    const [accessories, setAccessories] = useState([])
    const [modalNew, setModalNew] = useState(false)

    const [search, setSearch] = useState("")
    const [load, setLoad] = useState(false)

    /* ---------------------- Permission ------------------------- */
    const [myPermission, setMyPermission] = useState({ group: "", })
    const { checkPermission } = useMyPermission()
    const myPermissionNew = checkPermission(myPermission, "accessory_create")
    const myPermissionView = checkPermission(myPermission, "accessory_view")
    const myPermissionEdit = checkPermission(myPermission, "accessory_edit")
    const myPermissionDelete = checkPermission(myPermission, "accessory_delete")
    const myPermissionViewCost = checkPermission(myPermission, "accessory_viewCost")

    /* get all function */
    const getAll = () => {
        api.get(`/accessory/getall`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                setAccessories(response.data.accessories)
                setMyPermission(response.data.permission)
                setLoad(true)
            }
        })
    }

    /* use effect */
    useEffect(() => {
        getAll()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token])

    /* ----------------------- Search function ---------------------------------- */
    const filter = useMemo(() => {
        const searchLowerCase = search.toLowerCase()
        return accessories.filter((item) => item.name.toLowerCase().includes(searchLowerCase))
    }, [accessories, search])

    function handleSearch(e) {
        setSearch(e.target.value)
    }

    if (!load) {
        return <div className="pg-loading">Carregando acessórios...</div>
    }

    /* PAGE */
    return myPermissionView ? (
        <section className="pg-page">

            <div className="pg-sticky-top">
                <div className="pg-header">
                    <div className="pg-header-title">
                        <p className="pg-title">Acessórios</p>
                        <span className="pg-title-accent" />
                    </div>
                    <div className="pg-header-row">
                        <div className="pg-header-actions">
                            {myPermissionNew && (
                                <Button variant="new" onClick={() => setModalNew(true)}>Cadastrar</Button>
                            )}
                        </div>
                        <div className="pg-header-right">
                            <div className="pg-search">
                                <Input
                                    type="text"
                                    name="search"
                                    placeholder="Buscar por nome..."
                                    value={search}
                                    handleOnChange={handleSearch}
                                />
                            </div>
                            <span className="pg-count">
                                {filter.length} {filter.length === 1 ? 'acessório' : 'acessórios'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pg-list">
                {filter.length > 0 ? (
                    <ListAccessoryRow
                        dataArray={filter}
                        handleOnSuccess={getAll}
                        myPermissionEdit={myPermissionEdit}
                        myPermissionDelete={myPermissionDelete}
                        myPermissionView={myPermissionView}
                        myPermissionViewCost={myPermissionViewCost}
                    />
                ) : (
                    <div className="pg-empty">
                        <FiInbox size={32} className="pg-empty-icon" />
                        <p className="pg-empty-title">Nenhum acessório encontrado</p>
                        <p className="pg-empty-subtitle">
                            {accessories.length === 0
                                ? 'Cadastre o primeiro acessório para começar.'
                                : 'Tente ajustar a busca.'}
                        </p>
                    </div>
                )}
            </div>

            <Modal
                modalStatus={modalNew}
                changeStatus={setModalNew}
                w={80}
                content={
                    <NewAccessory btCancelAction={() => setModalNew(false)} handleOnSuccess={() => { setModalNew(false); getAll() }} />
                }
            />

        </section>
    ) : (
        <div className="pg-empty">
            <p className="pg-empty-title">Sem permissão para visualizar acessórios</p>
        </div>
    )
}

export default Accessory
